var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"Logo"},[_c('img',{staticClass:"Logo__image",attrs:{"src":_vm.$static.images.Logo,"alt":"Logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }